import { render } from "./PortfolioView.vue?vue&type=template&id=10c9be2d&scoped=true&ts=true"
import script from "./PortfolioView.vue?vue&type=script&lang=ts"
export * from "./PortfolioView.vue?vue&type=script&lang=ts"

import "./PortfolioView.vue?vue&type=style&index=0&id=10c9be2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c9be2d"]])

export default __exports__